import { render, staticRenderFns } from "./WithdrawBtn.vue?vue&type=template&id=68660704&scoped=true"
import script from "./WithdrawBtn.vue?vue&type=script&lang=js"
export * from "./WithdrawBtn.vue?vue&type=script&lang=js"
import style0 from "./WithdrawBtn.vue?vue&type=style&index=0&id=68660704&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68660704",
  null
  
)

export default component.exports